export const usePermissions = () => {
    const permission = useState('permission', () => ref([]));
    const permissionAll = useState('permissionAll', () => ref([]));
    const setPermission = (obj, objAll) => {
        permission.value = obj;
        permissionAll.value = objAll;
    };

    const permissionData = useState('permissionData');
    const setPermissionData = (list) => {
        permissionData.value = list;
    };
    return {
        permission,
        permissionAll,
        setPermission,
        permissionData,
        setPermissionData
    };
};
